export class DiContainerService {
    _services = {};
    addServiceByName(name, service) {
        this._services[name] = service;
        return this;
    }
    getServiceByName(name) {
        for (const key in this._services) {
            const entry = this._services[key];
            if (key === name) {
                return entry;
            }
        }
        return null;
    }
    getRequiredServiceByName(name) {
        const service = this.getServiceByName(name);
        if (!service) {
            throw new Error(`Required service named '${name}' is not registered`);
        }
        return service;
    }
}
//# sourceMappingURL=di-container-service.js.map